import ScrollerWidget from '../../widgets/ScrollerWidget';
import { tryFetch } from '../../widgetLoader';
import { loadWidgetData, RELOAD_INTERVAL } from './common';

export default async function mountScroller(host) {
	const widget = new ScrollerWidget({ container: host.container });
	await widget.init(await loadWidgetData(host, []));

	// Load historical alerts using the now-applied settings
	const itemCount = widget.settings.itemCount || 10;
	let alertsUrl = `widget/${encodeURIComponent(host.hash)}/alerts?limit=${itemCount}`;
	if(widget.settings.donationsOnly) alertsUrl += '&donationsOnly=1';
	const alerts = await tryFetch(() => host.api.get(alertsUrl), `cache-${host.hash}-alerts`);
	if(alerts) widget.applyAlerts(alerts);

	host.onSettingsChange(s => widget.applySettings(s));

	host.subscribe({
		reconnect: async () => widget.applySettings(await host.loadSettings()),
		userWidgetAlert: data => widget._onAlert(data),
	});

	host.every(async () => widget.applySettings(await host.loadSettings()), RELOAD_INTERVAL);
	host.onDestroy(() => widget.destroy());
}
